import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_product = async (product) => {
  try {
    let data = new FormData();
    data.append("image", product?.image[0]);
    data.append("name", product?.name);
    data.append("barcode", product?.barcode);
    data.append("unit", product?.unit);
    data.append("category", product?.category);
    data.append("brand", product?.brand);
    data.append("stock", product?.stock);
    data.append("expiry", product?.expiry);
    data.append("sale_price", product?.sale_price);
    data.append("purchase_price", product?.purchase_price);
    data.append("wholesale_price", product?.wholesale_price);
    data.append("tax", product?.tax);
    data.append("type", product?.type);
    data.append("status", product?.status);
    data.append("details", JSON?.stringify(product?.details));

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-product`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const create_bulk_product = async (product) => {
  try {
    let data = {
      details: product?.details,
      branch: product?.branch,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-bulk-product`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_product = async (product) => {
  try {
    let data = new FormData();
    data.append("id", product?.id);
    data.append("image", product?.image[0]);
    data.append("name", product?.name);
    data.append("barcode", product?.barcode);
    data.append("unit", product?.unit);
    data.append("category", product?.category);
    data.append("brand", product?.brand);
    data.append("stock", product?.stock);
    data.append("expiry", product?.expiry);
    data.append("sale_price", product?.sale_price);
    data.append("purchase_price", product?.purchase_price);
    data.append("wholesale_price", product?.wholesale_price);
    data.append("tax", product?.tax);
    data.append("type", product?.type);
    data.append("status", product?.status);
    data.append("details", JSON?.stringify(product?.details));

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-product`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_product = async (product) => {

  console.log("Fetching product with ID:", product);
  try {
    const data = {
      id: product?.id ? product?.id : product,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-product`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_product_name = async (product) => {
  try {
    const data = {
      name: product?.name,
      branch: product?.branch,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-product-name`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_products = async (product) => {
  try {
    const data = {
      search: product?.search,
      sort: product?.sort,
      unit: product?.unit,
      category: product?.category,
      brand: product?.brand,
      type: product?.type,
      status: product?.status,
      page: product?.page,
      source: product?.soruce,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-products`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_products_reports = async (product) => {
  try {
    const data = {
      search: product?.search,
      sort: product?.sort,
      unit: product?.unit,
      category: product?.category,
      brand: product?.brand,
      type: product?.type,
      status: product?.status,
      page: product?.page,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-products-reports`,
      data,
      config
    );

    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_product_unit_detail = async (product) => {
  try {
    const data = {
      id: product?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-product-unit-detail`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_product_barcode = async (product) => {
  try {
    const data = {
      barcode: product?.barcode,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-product-barcode`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_unavailable_products = async (product) => {
  try {
    const data = {
      branch: product?.branch,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-unavailable-products`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const create_products_csv = async (inventory) => {
  try {
    let data = new FormData();
    data.append("file", inventory?.file);

    const token = localStorage.getItem("user");

    const response = await axios.post(`${APIURL}/create-products-csv`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_product,
  create_bulk_product,
  update_product,
  get_product,
  get_product_name,
  get_all_products,
  get_all_products_reports,
  get_product_unit_detail,
  get_product_barcode,
  get_all_unavailable_products,
  create_products_csv,
};
